<template>
    <div class="authorize-device-page">
        <div class="authorizing-text">{{ $t('auth.authorizingDevice') }}...</div>
    </div>
</template>
<script>
    import {mapActions} from 'vuex'

    export default {
        data() {
            return {}
        },
        methods: {
            ...mapActions({
                authorizeDevice: 'authorizeDevice'
            }),
        },
        beforeCreate() {
            if (!this.$route.query.token) {
                this.$router.push('/login');
            }
        },
        mounted() {
            this.authorizeDevice(this.$route.query.token);
        },
    }
</script>
<style lang="scss">
    .authorize-device-page {
        height: 80vh;
        display: flex;
        text-align: center;
        align-items: center;

        .authorizing-text {
            width: 100%;
            font-size: 32px;
            color: #c4d1de;
        }
    }
</style>
